import React from 'react';

function pos(data) {
    if (!data || !data.roles) return "";

    const roleMap = {
        "1357797105955242075": "Chief",
        "1357797133100777643": "Deputy Chief",
        "1357797196371595435": "Captain",
        "1357797197697122465": "Lieutenant",
        "1357838020719415337": "Doktor",
        "1357797268064829481": "Paramedic",
        "1357797321089355826": "Emergency Medical Technician",
        "1357797370355646596": "Trainee",
    };

    for (const roleId of data.roles) {
        if (roleMap[roleId]) {
            return roleMap[roleId];
        }
    }

    return "";
}

function isTrainee(user) {
    return user?.roles?.includes("1357797370355646596");
}

function isInstructor(user) {
    return user?.roles?.includes("1357832069388177478");
}

function isDoc(user) {
    return user?.roles?.includes("1357838020719415337");
}

function isLeader(user) {
    const leaders = [
        "1357797196371595435",
        "1357797197697122465"
    ];

    return user?.roles?.some(role => leaders.includes(role));
}

function isOperational(user) {
    const leaders = [
        "1357797268064829481",
        "1357797321089355826"
    ];

    return user?.roles?.some(role => leaders.includes(role));
}

function isMainLeader(user) {
    const leaders = [
        "1357797105955242075",
        "1357797133100777643",
    ];

    return user?.roles?.some(role => leaders.includes(role));
}

const UserInfo = ({ user }) => {
    if (!user) return null;
    console.log(user)
    return (
        <div className="my-4">
            <img style={{maxHeight: "50px"}} src={`https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.png`}/>
            <div className="lead">
                <i class="bi bi-person-badge-fill"></i> {pos(user)} <b>{user.nickname}</b>
            </div>
            <div className="mt-2">
                {isTrainee(user) && (
                    <span className="badge color-trainee mx-1"><i className="bi bi-mortarboard"></i> Akademie</span>
                )}
                {isOperational(user) && (
                    <span className="badge color-operative mx-1"><i
                        className="bi bi-capsule"></i> Rychlá jednotka</span>
                )}
                {isLeader(user) && (
                    <span className="badge color-leader mx-1"><i className="bi bi-award"></i> Důstojník</span>
                )}
                {isMainLeader(user) && (
                    <span className="badge color-boss mx-1"><i className="bi bi-person-gear"></i> Vedení EMS</span>
                )}
                {isInstructor(user) && (
                    <span className="badge color-fto mx-1"><i className="bi bi-easel2"></i> Instruktor</span>
                )}
                {isDoc(user) && (
                    <span className="badge color-doc mx-1"><i
                        className="bi bi-lungs-fill"></i> Nemocniční personál</span>
                )}
            </div>
        </div>
    );
};

export default UserInfo;
